import { useCallback, useMemo, useState } from 'react'
import { ButtonPrimary } from '../../../../../../../../baseComponents/Button'
import LoaderDecider from '../../../../../../../../baseComponents/LoaderDecider'
import VerticalSortList from '../../../../../../../../baseComponents/Sorts/VerticalSortList'
import { VerticalSortItem } from '../../../../../../../../baseComponents/Sorts/VerticalSortList/types'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { WCalTurnConfigData } from '..'

interface ModalConfigTurnEmployeeOrderProps extends ModalConfigTurnEmployeeOrderLogicProps { 
    onSave: () => false
}

const ModalConfigTurnEmployeeOrder: React.FC<ModalConfigTurnEmployeeOrderProps> = ({ employees, onSave, setSelectedData, selectedData }) => {
    const memorizedEmployees = useMemo(() => employees, [employees])
    const { data, changeOrder } = useModalConfigTurnEmployeeOrderLogic({ employees: memorizedEmployees || {}, setSelectedData, selectedData })
    return (
        <div className='flex flex-col flex-auto'>
            <h2 className='mb-35'>
                <TwinTrans transKey='updateEmployeeOrder'>Actualizar el orden de empleados</TwinTrans>
            </h2>
            <div className='flex-auto h-1 flex-col flex'>
                <LoaderDecider loading={data === null}>
                    {data !== null && <VerticalSortList items={data as any} setItems={(value) => { changeOrder(value(data)) }}></VerticalSortList>}
                </LoaderDecider>
            </div>
            <ButtonPrimary className='mt-30 ml-auto' onClick={onSave}>
                <TwinTrans transKey='save'>Guardar</TwinTrans>
            </ButtonPrimary>
        </div>
    )
}

interface ModalConfigTurnEmployeeOrderLogicProps {
    employees: TwinDictionary
    setSelectedData: React.Dispatch<React.SetStateAction<WCalTurnConfigData>>
    selectedData: WCalTurnConfigData
}

const useModalConfigTurnEmployeeOrderLogic = ({ employees, setSelectedData, selectedData }: ModalConfigTurnEmployeeOrderLogicProps) => {
    const [data, setData] = useState<VerticalSortItem[] | null>(() => {
        const employeesToOrder: VerticalSortItem[] = []
        let index = 0
        for (const key in employees) {
            const employee = employees[key]
            index = index + 1
            employeesToOrder.push({
                name: employee.fullname_short,
                id: key,
                order: selectedData?.order?.[parseInt(key)] ? selectedData?.order?.[parseInt(key)].order : index
            })
        }
        employeesToOrder.sort((a, b) => a.order - b.order)
        return employeesToOrder
    })

    const changeOrder = useCallback(async (newOrder: VerticalSortItem[]) => {
        setData(newOrder)
        const myOrder = dictionaryComplexFromJsonArr(newOrder)
        setSelectedData((old) => {
            if (!old) {
                return old
            }
            const copyOld = JSON.parse(JSON.stringify(old))
            if (!copyOld['order']) {
                copyOld['order'] = {}
            }
            copyOld['order'] = { ...myOrder }
            return { ...copyOld }
        })
    }, [setData, setSelectedData])

    return { data, changeOrder }
}

export default ModalConfigTurnEmployeeOrder